import htmx from "htmx.org";
import ariaHelper from "./helpers/aria-helper";

export default {
    init() {
        let offset = 0;
        htmx.on("htmx:beforeSwap", function (event) {
            if (event.target.id == "news") {
                const loadMore = document.querySelector("#load-more-oob");
                if (loadMore === null) {
                    return;
                }

                offset = loadMore.getAttribute("data-offset");
            }
        });

        htmx.on("htmx:afterSwap", function (event) {
            if (event.target.id == "news") {
                handleAriaLabels();
                handleFocusReset();
            }
        });


        function handleAriaLabels() {
            const newsContainer = document.getElementById("news");
            if (newsContainer) {
                ariaHelper.setAriaLive(newsContainer);
            }
        }

        function handleFocusReset() {
            const articles = document.querySelectorAll("#news .card");
            if (articles.length === 0) {
                return;
            }

            const firstNewArticle = articles[offset]; // offset = old count
            if (firstNewArticle) {
                const focusTarget = firstNewArticle.querySelector("a, h2, h3, [tabindex]") || firstNewArticle;
                focusTarget.setAttribute("tabindex", "-1");
                focusTarget.focus();
            }
        }

        function handleFilter() {
            const container = document.getElementById("news-category-container");

            if (container) {
                const filter = container.querySelectorAll(".filter-head");
                const filterContent = container.querySelectorAll(".filter-body");

                if (filter) {
                    filter.forEach(filterHead => {
                        filterHead.addEventListener("click", function (event) {
                            let targetClicked = event.target;
                            targetClicked.parentNode.parentNode.classList.toggle("closed");

                            filterContent.forEach((elem) => {
                                if (targetClicked.parentNode.parentNode !== elem.parentNode) {
                                    if (!elem.parentNode.classList.contains("closed")) {
                                        elem.parentNode.classList.toggle("closed");
                                    }
                                }
                            })
                        }, false);
                    })
                }
            }
        }

        // Dropdown - selected item = error
        function handleDropdown() {
            //get elements
            const dropdownTitle = document.querySelector(".dropdown .title");
            const dropdownOptions = document.querySelectorAll(".dropdown .option");

            if (dropdownTitle && dropdownOptions) {

                //bind listeners to these elements
                dropdownTitle.addEventListener("click", toggleMenuDisplay);
                dropdownOptions.forEach(option => option.addEventListener("click", handleOptionSelected));
            }
        }

        function toggleClass(elem, className) {
            if (elem.className.indexOf(className) !== -1) {
                elem.className = elem.className.replace(className, "");
            } else {
                elem.className = elem.className.replace(/\s+/g, " ") + " " + className;
            }

            return elem;
        }


        function toggleMenuDisplay(e) {
            const dropdown = e.currentTarget.parentNode;
            const menu = dropdown.querySelector(".menu");

            toggleClass(menu, "hide");
        }

        function handleOptionSelected(e) {
            toggleClass(e.target.parentNode, "hide");

            const newValue = e.target.textContent + " ";
            const titleElem = document.querySelector(".dropdown .title");

            titleElem.textContent = newValue;

            //trigger custom event
            document.querySelector(".dropdown .title").dispatchEvent(new Event("change"));
        }

    },

}
